<template lang="pug">
.wrapper
    .container.m-auto
        HeaderGlobal(HeaderGlobalHeading="Upload App" :HeaderGlobalBreadcrumb="breadcrumb").py-4
        .box
            .box__header.no-border
                header.flex.items-center.justify-between
                    .header-meta
                        h2.subheading {{ page_title }}
                    .header-cta
                    //- router-link.btn-primary-o(to="/target")
                    //- button.btn-primary-o(@click="back()")
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" class="feather feather-arrow-left"><line x1="19" y1="12" x2="5" y2="12"></line><polyline points="12 19 5 12 12 5"></polyline></svg> 
                        span(style="padding-left: 8px;") Back
            .box__body
                .form.py-8
                    .flex
                        .block(class="w-2/12")
                        .block(class="w-8/12")
                            form(action="" method="method")
                            //- section target spesifict
                            section.group-fields.border-b.border-gray-200.mb-12.pb-8
                                //- name
                                //- .preview-avatar.relative.w-32.m-auto.mb-8
                                    img(:src="photo" @error="getDefaultImage").w-32.h-32.object-cover.rounded-full.border.mx-auto
                                    button.flex.items-center.justify-center.change-image.absolute.w-12.h-12.rounded-full.bg-gray-200.bottom-0.right-0.pointer
                                        input(type="file" @change="changeImgAvatar")
                                        span.text-gray-600
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-camera"><path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"></path><circle cx="12" cy="13" r="4"></circle></svg>
                                .field.flex.items-center.w-full.-mx-4.mb-16
                                    div.px-4(class="w-1/3").text-right
                                        label.block.text-sm.font-bold.mb-2(for="file_name") File Name *
                                    div.px-4(class="w-2/3")
                                        input.field-style(id="file_name" name="file_name" type="text" placeholder="Write File Name" v-model="file_name" maxlength="255")
                                        .absolute.pt-1.text-sm Latest file name is : {{ latest_file_name }}
                                        .error.absolute.pt-6.text-xs(v-if="error_file_name.length > 0") {{ error_file_name }}

                                .field.flex.items-center.w-full.-mx-4.mb-6
                                    div.px-4(class="w-1/3").text-right
                                        label.block.text-sm.font-bold.mb-2(for="file") File *
                                    div.px-4(class="w-2/3")
                                        input.field-style#file(type="file" placeholder="Upload File" @change="getFile")
                                        .absolute.pt-1.text-sm File extension is .apk &amp; max file size {{ ((max_file_size/1024)/1024).toFixed(1) }} MB
                                        .error.absolute.pt-6.text-xs(v-if="error_file.length > 0") {{ error_file }}
                                                                            
                            //-===== end section

                            .flex.items-center.justify-end.mb-8
                                //- button.btn-primary-o.mr-3 DRAFT
                                //- button.btn-primary SAVE
                                button.btn-default.btn-large.mr-3(type='button' @click="reset()")
                                    Strong Reset
                                //- button.btn-primary-o.btn-large.mr-3(type='submit' @click="submit($event, true)")
                                    Strong Save &amp; Continue
                                button.btn-primary.btn-large(type='submit' @click="submit")
                                    Strong Save

                        .block(class="w-2/12")                    
</template>

<script>
import { mapState } from 'vuex';
import HeaderGlobal from '@/components/HeaderGlobal.vue';

export default {
    name: 'PageUploadApp',
    components: {
        HeaderGlobal,
    },
    data: function() {
        return {
            latest_file_name: '',
            file_name: '',
            file: null,
            // error field
            error_file_name: '',
            error_file: '',

            breadcrumb: [
                {
                    name: 'Upload App',
                    url: '/upload-app',
                },
            ],
            page_title: 'Upload App',
            max_file_size: (process.env.VUE_APP_UPLOAD_APP_MAX_FILE_SIZE ? parseInt(process.env.VUE_APP_UPLOAD_APP_MAX_FILE_SIZE) : 52428800),
        }
    },
    computed: {
        ...mapState([
            'download_app',
        ]),
        route_name() {
            return this.$route.name;
        },
    },
    watch: {
        route_name() {
            this.getData();
        },
        download_app(newData) {
            // console.log(newData);
            if (Object.keys(newData).length > 0) {
                this.latest_file_name = (newData.file_name ? newData.file_name : '-');
                // this.file_name = (newData.file_name ? newData.file_name : '');
            }
        },
    },
    methods: {
        getFile(e) {
            if (e.target.files[0]) {
                if (e.target.files[0].type === 'application/vnd.android.package-archive') {
                    if (e.target.files[0].size > this.max_file_size) {
                        this.error_file = 'File size not more than 50 MB!';

                        var size = ((e.target.files[0].size/1024)/1024).toFixed(2);

                        if (document.getElementById('file'))
                            document.getElementById('file').value = '';

                        this.$swal.fire({
                            icon: 'error',
                            title: 'Failed!',
                            text: 'File size not more than 50 MB! Your file size is '+ size +' MB.',
                            // timer: 3000
                        });

                    } else {
                        this.file = e.target.files[0];
                    }

                } else {
                    if (document.getElementById('file'))
                        document.getElementById('file').value = '';

                    this.error_file_name = 'Please choose .apk file!';

                    this.$swal.fire({
                        icon: 'error',
                        title: 'Failed!',
                        text: 'Please choose .apk file!',
                        // timer: 3000
                    });
                }

            } else {
                this.file = null;
            }
        },
        getData() {
            this.file_name = '';
            this.file = '';

            this.error_file_name = '';
            this.error_file = '';

            if (document.getElementById('file'))
                document.getElementById('file').value = '';

            if (this.route_name === 'PageUploadApp') {

                this.showLoading(true);

                this.$store.dispatch('getDownloadApp')
                .then((resp) => {
                    if (resp.result === 'success') {

                        this.showLoading(false);

                    } else {
                        this.error();
                    }
                });

            }
        },
        reset() {
            this.$swal.fire({
                icon: 'warning',
                title: 'Are you sure you want to reset form?',
                // text: id,
                confirmButtonText: 'Yes!',
                confirmButtonColor: '#DD6B55',
                showCancelButton: true,
                allowOutsideClick: false,
            })
            .then((result) => {
                if (result.isConfirmed)
                    this.getData();
            });
        },
        // submit(e, save_continue=false){
        submit(e){
            e.preventDefault();

            this.showLoading(true);

            this.error_file_name = '';
            this.error_file = '';

            // validation
            if (this.file_name.length==0 || this.file==null || this.file.length==0) {

                this.error_file_name = (this.file_name.length==0 ? 'Field file name is required.' : '');
                this.error_file = (this.file==null || this.file.length==0 ? 'Field file is required.' : '');

                this.$swal.fire({
                    icon: 'warning',
                    title: 'Data is required!',
                    text: "File name & file is required!",
                });

                return;
            }

            if (this.file_name.length>255) {

                this.error_file_name = (this.file_name.length>255 ? 'Field operation name is not more than 255 characters.' : '');

                this.$swal.fire({
                    icon: 'warning',
                    title: 'Data length is not more than 255 characters!',
                    text: 'File name is not allowed more than 255 characters!',
                    // timer: 3000,
                });

                return;
            }

            this.$store.dispatch('getUploadApp', [this.file_name, this.file])
            .then((resp) => {
                if (resp.result === 'success') {

                    this.$swal.fire({
                        icon: 'success',
                        title: 'Data successfully saved!',
                        timer: 3000,
                    })
                    .then(() => {
                        this.getData();
                    });
                } else {
                    
                    if (resp.data.message && resp.data.message.errors) {
                        this.error_file_name = (resp.data.message.errors.file_name ? resp.data.message.errors.file_name : '');
                        this.error_file = (resp.data.message.errors.file ? resp.data.message.errors.file : '');

                        this.error(resp.data.message.errors);
                    } else {
                        this.error();
                    }
                }
            });
        },
        showLoading(show=true) {
            if (show) {
                this.$swal.fire({
                    title: '',
                    html: '<div class="save_loading"><svg viewBox="0 0 140 140" width="140" height="140"><g class="outline"><path d="m 70 28 a 1 1 0 0 0 0 84 a 1 1 0 0 0 0 -84" stroke="rgba(0,0,0,0.1)" stroke-width="4" fill="none" stroke-linecap="round" stroke-linejoin="round"></path></g><g class="circle"><path d="m 70 28 a 1 1 0 0 0 0 84 a 1 1 0 0 0 0 -84" stroke="#71BBFF" stroke-width="4" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-dashoffset="200" stroke-dasharray="300"></path></g></svg></div><div><h4>Loading...</h4></div>',
                    showConfirmButton: false,
                    allowOutsideClick: false
                });

            } else {
                this.$swal.close();
            }
        },
        error(data=null) {
            let errors = '';

            if (data !== null) {
                Object.keys(data).forEach(function (item) {
                    errors += data[item] + '<br><br>';
                    // errors += '<div class="swal2-html-container" style="display: block;">' + data[item] + '<div>';
                });
            }

            this.$swal.fire({
                icon: 'error',
                title: 'Failed!',
                text: 'Something wrong.',
                html: errors,
                // timer: 3000
            });
        },
    },
    mounted() {
        this.getData();
    },
}
</script>

<style lang="sass">

</style>


